import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import ApproveRepository from '../Repositories/ApproveRepository'


class ApproveBloc {

    approveChannel = new Subject();
    detailChannel = new Subject();
    repository = new ApproveRepository()
    educationChannel = new Subject()
    educationGroupChannel = new Subject()
    listJabatanChannel = new Subject();
   
    constructor() {
        this.approveChannel.next({status: apiResponse.INITIAL})
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.educationChannel.next({status: apiResponse.INITIAL})
        this.educationGroupChannel.next({status: apiResponse.INITIAL})
        this.listJabatanChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchApprove = async (query) => {
        try {
            this.approveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchApprove(query).then((result) => {
                this.approveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.approveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchEducation = async (query) => {
        try {
            this.educationChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEducation(query).then((result) => {
                this.educationChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.educationChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchEducationGroup = async (query) => {
        try {
            this.educationGroupChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchEducationGroup(query).then((result) => {
                this.educationGroupChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.educationGroupChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }
    fetchListJabatan = async (query) => {
        try {
            this.listJabatanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListJabatan(query).then((result) => {
                this.listJabatanChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listJabatanChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
}

export default ApproveBloc